module.exports = {
  scopes: ["openid", "email", "profile", "dealerAccount"],
  issuerLOCAL: "https://sso-dev.johndeere.com/oauth2/ausgnh0431ebF8iiL0h7",
  clientLOCAL: "0oa1cml8jdntmk65w0h8",
  issuerDEVL: "https://sso-dev.johndeere.com/oauth2/ausgnh0431ebF8iiL0h7",
  clientDEVL: "0oa1cml8jdntmk65w0h8",
  issuerCERT: "https://sso-cert.johndeere.com/oauth2/aus97etlxsNTFzHT11t7",
  clientCERT: "0oapacll1dIkyn7Od1t7",
  issuerPROD: "https://sso.johndeere.com/oauth2/aus9k0fb8kUjG8S5Z1t7",
  clientPROD: "0oapacqecujygawK81t7",

  localHost: "localhost:3000",
  talHost: "transactionpricingaws-devl.deere.com",
  certHost: "transactionpricingaws-cert.deere.com",
  ProdHost: "transactionpricing.deere.com",
  ProdHostTemp: "transactionpricingaws-prod.deere.com",

  TAL_FRONTEND: "transactionpricingaws-devl.deere.com",
  TAL_BACKEND: "https://mktg-services-devl.deere.com/mrkt/trans-pricing",

  CERT_FRONTEND: "transactionpricingaws-cert.deere.com",
  CERT_BACKEND: "https://mktg-services-cert.deere.com/mrkt/trans-pricing/cert",

  PROD_FRONTEND: "transactionpricing.deere.com",
  PROD_FRONTEND_TEMP: "transactionpricingaws-prod.deere.com",
  PROD_BACKEND: "https://mktg-services.deere.com/mrkt/trans-pricing",

  LOCAL_FRONTEND: "localhost",
  LOCAL_BACKEND: "http://localhost:8080/api",
};
